import { Http,HttpCase,HttpFormType } from "../Http";
export class AddAttorneyAPI {

  public static getallAttorneyDetails(input: any) {
    var url = "api/getAttorneyDetails/" + input.input;
    if (input === "") {
      return { data: [] };
    }

    const resultMethod = Http.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {

        return res;
      })
      .catch((e: any) => {
        return e.response;
      });

    return resultMethod;
  }

  public static saveAttorneyDetails(input: any) {
  
    var obj = JSON.stringify(input);
  //  var url = "api/saveAttorneyDetails";

    var url="formtypes/createAttorney/"+input.lawfirmId;
 
    const resultMethod = HttpFormType.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
           return res;
      }).catch((e: any) => {
   
        return e.response;
      });
    return resultMethod;
  }

  public static getAttorneyDetailsByCompanyId(input: any) {
    var url = "api/getAttorneyDetailsByCompanyId/" + input.input;
    if (input === "") {
      return { data: [] };
    }

    const resultMethod = Http.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {

        return res;
      })
      .catch((e: any) => {
        return e.response;
      });

    return resultMethod;
  }


  public static  updateAttorneyDetailsInput(input: any){
    //var url = "api/saveAttorneyDetails";
    var url="formtypes/updateAttorney/";
    
    var obj=JSON.stringify(input);   
    if (input === "") {
      return { data: [] };
    }
   
    const resultMethod = HttpFormType.axios().put(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
       
        return res;
      }).catch((e: any) => {
     
        return e.response;
      });
    return resultMethod;
    }



    public static createCaseFlowg28(input: any) {
  
      var obj = JSON.stringify(input);
      var url = "caseflow/createCaseFlowg28";
      const resultMethod = HttpCase.axios().post(url, obj,
        {
          headers: {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "*",
            "Access-Control-Allow-Headers": "*"
          }
        })
        .then(res => {
             return res;
        }).catch((e: any) => {
     
          return e.response;
        });
      return resultMethod;
    }
  
    public static getCaseFlowG28ByCaseId(input: any) {
      var url = "caseflow/getCaseFlowG28ByCaseId/" + input.input+"?g28Type="+input.inputParam;;
      if (input === "") {
        return { data: [] };
      }
 
      const resultMethod = HttpCase.axios()
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          }
        })
        .then(res => {
  
          return res;
        })
        .catch((e: any) => {
          return e.response;
        });
  
      return resultMethod;
    }
  
  
    public static  updateCaseFlowg28(input: any){
      var url = "caseflow/updateCaseFlowg28";    
      var obj=JSON.stringify(input);   
     
      if (input === "") {
        return { data: [] };
      }
      const resultMethod = HttpCase.axios().put(url, obj,
        {
          headers: {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "*",
            "Access-Control-Allow-Headers": "*"
          }
        })
        .then(res => {
         
          return res;
        }).catch((e: any) => {
       
          return e.response;
        });
      return resultMethod;
      }

      public static  g28PdfGenerationNew(input: any){
        
        var url = "caseflow/g28PdfGenerationNew/"+ input;
      
        if (input === "") {
          return { data: [] };
        }
        const resultMethod = HttpCase.axios().post(url, { headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*" 
        } } ).then(res => {
           
            return res;
          }).catch((e: any) => {
         
            return e.response;
          });
        return resultMethod;
        }
      

}